<template>
	<ValidationObserver ref="observer" v-slot="{ passes }">
		<form @submit.prevent="passes(() => {})" autocomplete="disabled" onkeydown="return event.key != 'Enter';">
			<div class="mdl-grid">
				<div class="mdl-cell mdl-cell--12-col mdl-cell--12-col-m form-group">
					<label>{{ T("email") }}</label>
					<ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
						<input v-model.trim="username" type="text" class="mdl-textfield__input" />
						<span class="error">{{ errors[0] }}</span>
					</ValidationProvider>
				</div>
			</div>
		</form>
	</ValidationObserver>
</template>

<script>
	import {
		ValidationObserver,
		ValidationProvider
	} from "vee-validate";
	import defaultMixin from "../../mixins/default";

	export default {
		name: "d21-modal-forgot-password",
		mixins: [defaultMixin],
		components: {
			ValidationObserver,
			ValidationProvider
		},
		data() {
			return {
				username: '',
				isPasswordChanged: false,
				hasError: false,
				isResetMailSent: false,
			}
		},
		methods: {
			updateInputs() {
				this.$emit("update:content", {
					username: this.username,
				});
			}
		},
		watch: {
			username() {
				this.updateInputs();
			},
		}
	}
</script>